import React from 'react'
import PropTypes from 'prop-types'
/*
 * @param {number} height;
 * @param {number} width;
 * @param {hex color} fill;
 * @param {string} title - really just alt text;
 */
const MultipleAirlinesIcon = ({ height = 27, width = 36, fill = '#ABB7C2', title = 'Multiple Airlines' }) => (
  <svg
    className='pclnOne-MulipleAirlinesIcon'
    width={width}
    height={height}
    viewBox='0 0 36 27'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    data-testid='multiple-airlines'
    aria-labelledby='display-multiple-airlines'
  >
    <title id='display-multiple-airlines'>{title}</title>
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Multiple-Airlines'>
        <g
          id='air'
          transform='translate(10.000000, 10.000000) rotate(-270.000000) translate(-10.000000, -10.000000) '
        >
          <polygon id='Shape' points='0 0 20 0 20 20 0 20' />
          <path
            d='M18,13.9 L18,12.2 L11.2631579,7.95 L11.2631579,3.275 C11.2631579,2.5695 10.6989474,2 10,2 C9.30105263,2 8.73684211,2.5695 8.73684211,3.275 L8.73684211,7.95 L2,12.2 L2,13.9 L8.73684211,11.775 L8.73684211,16.45 L7.05263158,17.725 L7.05263158,19 L10,18.15 L12.9473684,19 L12.9473684,17.725 L11.2631579,16.45 L11.2631579,11.775 L18,13.9 Z'
            id='Shape'
            fill={fill}
            fillRule='nonzero'
          />
        </g>
        <g
          id='air-copy'
          transform='translate(26.000000, 17.000000) rotate(-270.000000) translate(-26.000000, -17.000000) translate(16.000000, 7.000000)'
        >
          <polygon id='Shape' points='0 0 20 0 20 20 0 20' />
          <path
            d='M18,13.9 L18,12.2 L11.2631579,7.95 L11.2631579,3.275 C11.2631579,2.5695 10.6989474,2 10,2 C9.30105263,2 8.73684211,2.5695 8.73684211,3.275 L8.73684211,7.95 L2,12.2 L2,13.9 L8.73684211,11.775 L8.73684211,16.45 L7.05263158,17.725 L7.05263158,19 L10,18.15 L12.9473684,19 L12.9473684,17.725 L11.2631579,16.45 L11.2631579,11.775 L18,13.9 Z'
            id='Shape'
            fill={fill}
            fillRule='nonzero'
          />
        </g>
      </g>
    </g>
  </svg>
)

MultipleAirlinesIcon.propTypes = {
  fill: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  title: PropTypes.string,
}

export default MultipleAirlinesIcon
